import React from "react";
import { Circle, Item, Square, Triangle } from "./styles";
import { Calendar as AntdCalendar, ConfigProvider } from "antd";
import dayjs, { Dayjs } from "dayjs";
import "dayjs/locale/pt-br";
import ptBR from "antd/es/locale/pt_BR";
import { Column } from "../../../../../../themes/globalStyle";
import Typography from "../../../../../../components/Typography";
import usePost from "../../hooks/usePost";

const Calendar: React.FC = (): JSX.Element => {
  const { postState, updateState } = usePost();

  const switchCaption = (item: string) => {
    switch (item) {
      case "triangle":
        return <Triangle />;
      case "circle":
        return <Circle />;
      case "square":
        return <Square />;

      default:
        return <></>;
    }
  };
  const getListData = (value: Dayjs) => {
    const dateString = value.format("YYYY-MM-DD");
    return postState.posts
      ?.filter((item) => dayjs(item.date).format("YYYY-MM-DD") === dateString)
      .map((item) => ({
        content: postState.groups.filter(
          (post) => post.smartGoalId === item.smart_goal_id
        )?.[0],
      }));
  };

  const dateCellRender = (value: Dayjs) => {
    const listData = getListData(value);
    return (
      <Column style={{ gap: "0.25rem" }}>
        {listData?.map((item, index) => (
          <Item
            key={item.content.smartGoalId + index}
            onClick={() =>
              updateState({ selectedSmartGoal: item.content.smartGoalId })
            }
          >
            {switchCaption(item.content.view)}
            <Typography
              text={item.content.title}
              size="tiny"
              color="Black400"
              weight={500}
            />
          </Item>
        ))}
      </Column>
    );
  };

  return (
    <ConfigProvider locale={ptBR}>
      <AntdCalendar cellRender={dateCellRender} />
    </ConfigProvider>
  );
};

export default Calendar;
